import { render } from "./DashboardPage.vue?vue&type=template&id=5f16b162"
import script from "./DashboardPage.vue?vue&type=script&lang=ts"
export * from "./DashboardPage.vue?vue&type=script&lang=ts"
script.render = render

export default script